<template>
    <div v-if="visible" id="no-connection" data-backdrop="static" data-keyboard="false">
        <a-modal :visible="true" id="no-connection-amodal" wrapClassName="vertical-center-modal" class="modal-dialog">
            <span class="loader"></span>
            <p class="noConnectionText">{{ $t("message.noConnection") }}</p>
        </a-modal>
    </div>
</template>
<script>
import { mapState, mapMutations } from "vuex";
import moment from "moment";

export default {
    data() {
        return {
            visible: false,
            cancels: [],
        };
    },
    methods: {
        ...mapMutations({
            SET_NET_CONNECTION_STATUS: "app/SET_NET_CONNECTION_STATUS",
        }),
    },
    computed: {
        ...mapState({
            isNetConnectionStatusOnline: (state) => state.app.isNetConnectionStatusOnline,
            lastOfflineTimeStamp: (state) => state.app.lastOfflineTimeStamp,
        }),
    },
    created() {
        const onlineCB = () => this.SET_NET_CONNECTION_STATUS(true);
        window.addEventListener("online", onlineCB);
        this.cancels.push(() => window.removeEventListener("online", onlineCB));

        const offlineCB = () => this.SET_NET_CONNECTION_STATUS(false);
        window.addEventListener("offline", offlineCB);
        this.cancels.push(() => window.removeEventListener("offline", offlineCB));
    },
    beforeDestroy() {
        this.cancels.forEach((x) => x());
    },
    watch: {
        isNetConnectionStatusOnline(isOnline) {
            if (isOnline) {
                this.visible = false;
            } else {
                setTimeout(() => {
                    const diff = Date.now() - this.lastOfflineTimeStamp;
                    if (diff >= 3000) {
                        this.visible = !this.isNetConnectionStatusOnline;
                    }
                }, 5000);
            }
        },
    },
};
</script>
<style lang="scss">
#no-connection {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    display: flex;
    z-index: 999999999999999999999 !important;
    position: fixed;
    background-color: rgba(0, 0, 0, 0.3);
    color: white;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 20px;

    .modal-dialog {
        max-width: 100%;
        margin: 0;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
    }
}

#no-connection-amodal {
    .ant-modal-content {
        display: flex;
        justify-content: center;
        text-align: center;
        align-items: center;
        color: #000;
        background-clip: padding-box !important;
        background-color: transparent !important;
        pointer-events: auto !important;
        position: relative;
        box-shadow: none !important;
        border: none !important;
    }

    .ant-modal-footer {
        display: none;
    }

    .ant-modal-header {
        display: none;
    }

    .ant-modal-close-x {
        display: none;
    }

    .vertical-center-modal {
        text-align: center;
        white-space: nowrap;
    }

    .vertical-center-modal:before {
        content: "";
        display: inline-block;
        height: 100%;
        vertical-align: middle;
        width: 0;
    }

    .vertical-center-modal .ant-modal {
        display: inline-block;
        vertical-align: middle;
        top: 0;
        text-align: left;
    }
}

.loader {
    box-sizing: border-box;
    display: inline-block;
    width: 50px;
    height: 80px;
    border-top: 5px solid #fff;
    border-bottom: 5px solid #fff;
    position: relative;
    background: linear-gradient(#ff3d00 30px, transparent 0) no-repeat;
    background-size: 2px 40px;
    background-position: 50% 0px;
    animation: spinx 5s linear infinite;
}

.loader:before,
.loader:after {
    content: "";
    width: 40px;
    left: 50%;
    height: 35px;
    position: absolute;
    top: 0;
    transform: translatex(-50%);
    background: rgba(225, 225, 225, 0.4);
    border-radius: 0 0 20px 20px;
    background-size: 100% auto;
    background-repeat: no-repeat;
    background-position: 0 0px;
    animation: lqt 5s linear infinite;
}

.loader:after {
    top: auto;
    bottom: 0;
    border-radius: 20px 20px 0 0;
    animation: lqb 5s linear infinite;
}

@keyframes lqt {
    0%,
    100% {
        background-image: linear-gradient(#fd7e14 40px, transparent 0);
        background-position: 0% 0px;
    }
    50% {
        background-image: linear-gradient(#fd7e14 40px, transparent 0);
        background-position: 0% 40px;
    }
    50.1% {
        background-image: linear-gradient(#fd7e14 40px, transparent 0);
        background-position: 0% -40px;
    }
}

@keyframes lqb {
    0% {
        background-image: linear-gradient(#fd7e14 40px, transparent 0);
        background-position: 0 40px;
    }
    100% {
        background-image: linear-gradient(#fd7e14 40px, transparent 0);
        background-position: 0 -40px;
    }
}

@keyframes spinx {
    0%,
    49% {
        transform: rotate(0deg);
        background-position: 50% 36px;
    }
    51%,
    98% {
        transform: rotate(180deg);
        background-position: 50% 4px;
    }
    100% {
        transform: rotate(360deg);
        background-position: 50% 36px;
    }
}

.noConnectionText {
    color: white;
    letter-spacing: 6px;
    font-weight: 600;
    z-index: 1;
}
</style>
